import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";


export class committeeChairman extends EntityDto implements IEntityDto {
  Chairman_Emp_Ref_Id: string|undefined;
  ChairmanJoiningDate:  Date | undefined;
  ChairmanInChargeTill_Id: number;
  ChairmanInChargeTillDate: Date|undefined;
  ChairmanInChargeTillTenure: number;
  ChairmanName: string|undefined;
  Till:string|null ="";
  ChairmanJoiningDatestr:string|null="";
  Committee_Id: string;
  Emp_Ref_Id: string| undefined;
  EmployeeName: string;
  IsActive: boolean;
  UserName: string;  
  ChairmanEditBit:number;
  ChairmanInChargeTillDatestr:string| null ="";
  constructor() {
    super();
    this.Chairman_Emp_Ref_Id = '';
    this.ChairmanName = '';    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.IsActive = true;
    this.EmployeeName = ''; 
    this.Emp_Ref_Id ='';
    this.ChairmanInChargeTill_Id = 0;
    this.ChairmanInChargeTillTenure = 0;
    this.UserName = "";
    this.ChairmanEditBit = 0;
  }
}